import { el, formatBytes, sanitizeFilename } from "./dom";

/**
 * Custom in-app accept/decline dialog for an incoming file. Returns a promise
 * that resolves true (accept) or false (decline). Replaces native confirm().
 */
export function confirmIncoming(name: string, size: number): Promise<boolean> {
  return new Promise((resolve) => {
    const safeName = sanitizeFilename(name);

    const finish = (accepted: boolean): void => {
      overlay.remove();
      document.removeEventListener("keydown", onKey);
      resolve(accepted);
    };
    const onKey = (e: KeyboardEvent): void => {
      if (e.key === "Escape") finish(false);
    };

    const card = el(
      "div",
      { class: "modal", role: "dialog", "aria-modal": "true" },
      el("h2", { class: "modal-title", text: "Incoming file" }),
      el(
        "p",
        { class: "modal-body" },
        el("strong", { text: safeName }),
        el("span", { class: "muted", text: ` \u00b7 ${formatBytes(size)}` })
      ),
      el(
        "div",
        { class: "modal-actions" },
        el(
          "button",
          { class: "btn btn-ghost", onclick: () => finish(false) },
          "Decline"
        ),
        el(
          "button",
          { class: "btn btn-primary", onclick: () => finish(true) },
          "Accept"
        )
      )
    );

    const overlay = el("div", { class: "modal-overlay" }, card);
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) finish(false);
    });
    document.addEventListener("keydown", onKey);
    document.body.append(overlay);
  });
}
